// extracted by mini-css-extract-plugin
export default {"form":"styles_form__gg8r7","datePicker":"styles_datePicker__cLcXY","item":"styles_item__YOFC9","label":"styles_label__Co15J"};